import './MaryanaLanding.sass';

import React, { FC, useCallback, useEffect } from 'react';

import { Button } from '$uikit';
import { IcLogo40 } from '$assets';
import { AuthPopoverSimple } from '$core/AuthPopover/AuthPopover';
import { profileActions } from '$store/profile';
import { AuthPopoverState } from '$store/models';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from '$store/auth';
import { goTo } from '$navigation/helper';
import { PROFILE, RESOLVE } from '$shared/constants/pages';
import { statReachGoal } from '$utils';

export const MaryanaLanding: FC = () => {
  const dispatch = useDispatch();
  const { isLogged } = useSelector(authSelector);

  useEffect(() => {
    statReachGoal('maryana_landing_open');
  }, []);

  const handleAuth = useCallback(() => {
    statReachGoal('maryana_landing_button_click');
    if (isLogged) {
      goTo(RESOLVE, {
        domain: 'maryanaro',
      });
    } else {
      dispatch(profileActions.setAuthPopoverState(AuthPopoverState.LOGIN));
    }
  }, [isLogged]);

  return (
    <div className="MaryanaLanding">
      <div className="MaryanaLanding__head">
        <div className="Navbar__logo">
          <IcLogo40 />
          Ton.Place
        </div>
      </div>
      <div className="MaryanaLanding__content">
        <video
          src={require('./assets/video.mp4').default}
          poster={require('./assets/poster.jpg').default}
          controls
          playsInline
          onPlay={() => statReachGoal('maryana_landing_play_video')}
          preload="auto"
        />
      </div>
      <div className="MaryanaLanding__footer">
        <Button flare onClick={handleAuth}>Смотреть контент</Button>
      </div>
      <AuthPopoverSimple />
    </div>
  );
};
